import React from "react";
import "../styles/articles.css";
import arrow from "../images/articles/subscribeArrow.png";

const articles = ({ articleData }) => {
  return (
    <>
      <section className="articles-landing">
        <div className="articles-landing-header">
          <h1>Our latest news, ideas and articles</h1>
        </div>
        <div className="articles-landing-subscribe">
          <h2>Subscribe to our mailing list</h2>
          <button className="articles-button">
            <img src={arrow} alt="Arrow to subscribe" />
          </button>
        </div>
      </section>

      <section className="articles">
        <div className="articles-wrap">
          {articleData.map((article) => (
            <div
              className="article"
              key={article.id}
              style={{ backgroundImage: `url(${article.img})` }}
            >
              <div className="article-content">
                <h2>{article.title}</h2>
                <button className="articles-button">
                  <a
                    href={article.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={arrow} alt="Read more here" />
                  </a>
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default articles;
